module.exports = __webpack_public_path__ + "static/media/imageUp.930bcb1e.png";